import { useMemo } from 'react'

import { useFileUploadContext } from './useFileUploadContext'

export function useFileUploadFileListState() {
    const { listId, files } = useFileUploadContext()

    const shouldShow = files.length > 0

    const items = useMemo(() => Array.from(files.values()), [files])

    return {
        shouldShow,
        listId,
        items,
    }
}
